import axios from "axios";

// common API call function
const requestGetCall = async (baseData, req) => {
  const options = {
    method: baseData.method,
    url: baseData.endPoint,
    headers: baseData.headers,
    data: req,
    withCredentials: true,
  };

  try {
    const response = await axios(options);
    console.log("MAIN_RES", response);
    return onSuccess(response);
  } catch (error) {
    console.log("MAIN_ERR", error);
    return onError(error);
  }
};

const onSuccess = (response) => {
  console.debug("Request Successful!", response);
  return response;
};

const onError = (error) => {
  console.log("Request Failed:", error.config);
  if (error.response) {
    console.log("Status:", error.response.status);
    console.log("Data:", error.response.data);
    console.log("Headers:", error.response.headers);
  } else {
    console.log("Error Message:", error.message);
  }
  return Promise.reject(error.response || error.message);
};

export default requestGetCall;

const _requestGetCall = (baseData) => {
  const options = {
    method: baseData.method,
    url: baseData.endPoint,
    headers: baseData.headers,
  };
  const onSuccess = (response) => {
    console.debug("Request Successful!", response);
    return response;
  };
  const onError = (error) => {
    console.log("Request Failed:", error.config);
    if (error.response) {
      console.log("Status:", error.response.status);
      console.log("Data:", error.response.data);
      console.log("Headers:", error.response.headers);
    } else {
      console.log("Error Message:", error.message);
    }
    return Promise.reject(error.response || error.message);
  };
  return axios(options).then(onSuccess).catch(onError);
};
// export default requestGetCall;
